import { Color, ContentfulRichTextBlock, MediaAsset, Sys } from 'libs/contentful/types';
import { getColorwayName } from 'utils/formatters';
import RichTextCopy from '../RichTextCopy/RichTextCopy';
import RichTextHeadline from '../RichTextHeadline/RichTextHeadline';
import Media from '../Media/Media';
import { cn } from 'utils/styles';
import { Colorways } from 'types/constants';
import ChimeLogo from '../ChimeLogo/ChimeLogo';

import FiveStars from '../Icons/FiveStar';
import { liveUpdateAttrs } from 'libs/contentful/utils';

interface EyebrowComponentProps {
  sys?: Sys;
  showFiveStars?: boolean;
  eyebrowText?: ContentfulRichTextBlock;
  eyebrowAlternateLogo?: MediaAsset;
  eyebrowChimeLogo?: boolean;
  color?: Color;
  className?: string;
  isHeading?: boolean;
}

const Eyebrow = ({
  showFiveStars,
  eyebrowAlternateLogo,
  eyebrowChimeLogo,
  eyebrowText,
  color,
  className,
  isHeading,
  sys,
}: EyebrowComponentProps) => {
  const text = (
    <div className="text-eyebrow font-sans" {...liveUpdateAttrs(sys?.id, 'eyebrowText')} data-testid="eyebrow-text">
      {eyebrowText && isHeading ? (
        <RichTextHeadline headline={eyebrowText} level="h2" />
      ) : (
        <RichTextCopy copy={eyebrowText} />
      )}
    </div>
  );

  const logo = (
    <div
      className="eyebrow-logo"
      {...liveUpdateAttrs(sys?.id, 'eyebrow')}
      data-testid="eyebrow-logo"
      data-theme={'dark'}>
      <ChimeLogo
        color={getColorwayName(color!) === Colorways.ActionPrimary ? 'primary_neutral' : 'chime_green'}
        size="large"
        alt="Chime"
        className="h-6 w-auto"
      />
    </div>
  );

  const alternateLogo = (
    <div {...liveUpdateAttrs(sys?.id, 'eyebrow')} data-testid="eyebrow-alternate-logo">
      <Media className="rounded-none" media={eyebrowAlternateLogo!} />
    </div>
  );

  const fiveStarEyebrow = (
    <div {...liveUpdateAttrs(sys?.id, 'showFiveStars')} data-testid="eyebrow-five-stars">
      <FiveStars />
    </div>
  );

  // Only display one eyebrow at a time, even if multiple are defined
  // Order of preference Alternate Logo > Chime Logo > Text
  const displayEyebrow = () => {
    if (showFiveStars) return fiveStarEyebrow;
    if (eyebrowAlternateLogo?.url != null) return alternateLogo;
    if (eyebrowChimeLogo) return logo;
    if (eyebrowText != null) return text;
    return null;
  };

  return <div className={cn('empty:hidden mb-4', className)}>{displayEyebrow()}</div>;
};

export default Eyebrow;
